import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { SortDirection } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { AppServerAPI } from '@sdbn/common';
import { TransportScope } from "../../../../../common/model/transport.model";
import { PendingTaskState, Transport } from '../../../transport-list/model';
import { PlannedTransport, TransportSelection } from '../../model/sac-client.model';

@Component({
    selector: 'app-planned-transport-selection',
    templateUrl: './planned-transport-selection.component.html',
    styleUrls: ['./planned-transport-selection.component.scss'],
    standalone: false
})
export class MovingOrderTransportSelectionComponent implements OnInit {

  readonly TransportScope = TransportScope;
  readonly PendingTaskState = PendingTaskState;

  dataSource: MatTableDataSource<PlannedTransport> = new MatTableDataSource(new Array<PlannedTransport>());

  form: FormGroup;

  selection = new TransportSelection({
    dateFrom: new Date(),
    dateUntil: new Date(),
    query: '',
    targetStationId: null,
    onlyPlanned: true
  });

  @Input() mode: string;

  @Input() onlyPlanned: boolean;

  @Input() findOnlyNextPlannedRoutingPosition: boolean;

  @Input() targetStationId: number;

  @Output() selectedTransport = new EventEmitter<number>();

  defaultVisibleColumns = [
    'hint', 'carrier', 'supplier', 'identifier', 'driver', 'visitStatusDict', 'string1', 'string2', 'start', 'reference', 'options', 'cargo', 'planningDate', 'messagingResources'
  ];

  columnsToDisplay = this.defaultVisibleColumns;

  sortColumn = 'start';

  sortDirection: SortDirection = 'asc' as SortDirection;

  selectedListEntry: Transport;

  constructor(
    private appServerAPI: AppServerAPI
  ) {

    this.form = new FormGroup({
      dateFrom: new FormControl(new Date(), []),
      dateUntil: new FormControl(new Date(), []),
      query: new FormControl('', [])
    });

    this.form.valueChanges.subscribe(values => {

      this.selection = new TransportSelection({
        dateFrom: values.dateFrom,
        dateUntil: values.dateUntil,
        query: values.query
      });

    });

  }

  ngOnInit(): void {
    this.selection = new TransportSelection({
      dateFrom: new Date(),
      dateUntil: new Date(),
      query: ''
    });
    this.loadPlannedTransports();
  }

  public sortChanged(event) {
  }

  toggleSelection(transport: any) {
    console.log(transport);
    this.selectedListEntry = transport;
    this.selectedTransport.next(transport.id);
  }

  loadPlannedTransports() {

    this.selection.onlyPlanned = this.onlyPlanned;
    this.selection.findOnlyNextPlannedRoutingPosition = this.findOnlyNextPlannedRoutingPosition;
    this.selection.targetStationId = this.targetStationId;

    this.appServerAPI.execute<any[]>(`/client/control/sac-client/find-planned-transports`, this.selection).subscribe(
      plannedTransports => {

        let data = new Array<PlannedTransport>();

        for (const plannedTransport of plannedTransports) {
          data.push(new PlannedTransport(plannedTransport));
        }

        this.dataSource = new MatTableDataSource(data);

      }
    );

  }

  refresh() {
    this.loadPlannedTransports();
  }

}
